var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from "axios";
import { getAppRoot } from "@/onload/loadConfig";
import { rethrowSimple } from "@/utils/simple-error";
import {} from ".";
export function getCitations(source, id) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const request = yield axios.get(`${getAppRoot()}api/${source}/${id}/citations`);
            const rawCitations = request.data;
            const citations = [];
            const { Cite } = yield import(/* webpackChunkName: "cite" */ "./cite");
            for (const rawCitation of rawCitations) {
                try {
                    const cite = new Cite(rawCitation.content);
                    citations.push({ raw: rawCitation.content, cite: cite });
                }
                catch (err) {
                    console.warn(`Error parsing bibtex: ${err}`);
                }
            }
            return citations;
        }
        catch (e) {
            rethrowSimple(e);
        }
    });
}
